var map = {
	"./start1.png": "0X9t",
	"./start1_1.png": "Ei+C",
	"./start2.png": "FkGE",
	"./start2_1.png": "aRvf",
	"./start3.png": "8LvG",
	"./start3_1.png": "+tsX",
	"./start4.png": "g57k",
	"./start4_1.png": "osYZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BxUZ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/start.*\.png$
// module id = BxUZ
// module chunks = 1